module.exports = {
  siteTitle: 'Matt Williams',
  siteTitleAlt: 'Matt Williams', // This allows an alternative site title for SEO schema.
  publisher: 'Matt Williams - Data Scientist', // Organization name used for SEO schema
  siteDescription:
    'A personal CV Portfolio Website to showcase my work and open-source projects.',
  siteUrl: 'https://mattw.xyz', // Site domain. 
  postsPerHomePage: 7, // Number of posts shown on the 1st page of of the index.js template (home page)
  postsPerPage: 6, // Number of posts shown on paginated pages
  author: 'Matt Williams', // Author for RSS author segment and SEO schema
  authorUrl: 'https://mattw.xyz/about/', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@twitter', // Change for Twitter Cards
  shortTitle: 'Matt Williams', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 900, // Change to the width of your default share image
  shareImageHeight: 600, // Change to the height of your default share image
  siteLogo: '/logos/logo-512.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  themeColor: '#121212', // Used for Offline Manifest
  copyright: 'Copyright © 2019 Matt Williams', // Copyright string for the RSS feed
}
